import { render, staticRenderFns } from "./api-menu.vue?vue&type=template&id=153ce88c&scoped=true"
import script from "./api-menu.vue?vue&type=script&lang=js"
export * from "./api-menu.vue?vue&type=script&lang=js"
import style0 from "./api-menu.scss?vue&type=style&index=0&id=153ce88c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ce88c",
  null
  
)

export default component.exports